import { ChevronDownIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { mergeStyling } from '../../common-functions';

type SelectProps = Omit<ComponentProps<'select'>, 'size'> & {
  size?: 'sm' | 'default';
};

const Select = ({ className, size = 'default', ...props }: SelectProps) => {
  return (
    <div
      className={mergeStyling('group/select relative w-fit has-[select:disabled]:opacity-50', className)}
      data-slot="select-wrapper"
      data-size={size}
    >
      <select
        data-slot="select"
        data-size={size}
        className={mergeStyling(
          'h-8 w-full min-w-0 select-none appearance-none py-1 pr-9 pl-2.5 text-sm',
          'rounded-sm border border-gray-4 bg-mono-1 outline-none',
          'selection:bg-primary-2 selection:text-mono-1',
          'placeholder:text-gray-3 [&:has(option[value=""]:checked)]:text-gray-3',
          'focus-visible:border-primary-2',
          'disabled:pointer-events-none disabled:cursor-not-allowed',
          'aria-invalid:border-error',
          'data-[size=sm]:h-7 data-[size=sm]:py-0.5'
        )}
        {...props}
      />
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-2 size-4 -translate-y-1/2 select-none text-gray-2"
        aria-hidden="true"
        data-slot="select-icon"
      />
    </div>
  );
};

const SelectOption = ({ className, ...props }: ComponentProps<'option'>) => {
  return <option data-slot="select-option" className={mergeStyling('bg-mono-1 text-gray-1', className)} {...props} />;
};

const SelectOptGroup = ({ className, ...props }: ComponentProps<'optgroup'>) => {
  return (
    <optgroup data-slot="select-optgroup" className={mergeStyling('bg-mono-1 text-gray-1', className)} {...props} />
  );
};

export { Select, SelectOptGroup, SelectOption };
